import { Redirect } from 'react-router';
import { Switch, Route } from 'react-router-dom';
import { useState } from 'react';
import queryString from 'qs';
import withAuthProtection from 'hoc/withAuthProtection';
import Profile from '../Profile';
import W4s from '../W4s';
import Loanout from '../Loanout';
import CrewSupport from '../CrewSupport';

import TrayBar from './TrayBar';

const OfferRoute = Component => props => <Component offer={true} {...props} />;

const OfferPage = ({ location }) => {
  const { search = '' } = location;
  const { offerId, from } = queryString.parse(search.slice(1));
  const [offer] = useState(offerId);
  const [fromSystem] = useState(from);
  return (
    <>
      <Switch>
        <Route path="/offer/profile" exact={true} component={Profile} />
        <Route path="/offer/w4s" exact={true} component={OfferRoute(W4s)} />
        <Route
          path="/offer/loanout"
          exact={true}
          component={OfferRoute(Loanout)}
        />
        <Route path="/offer/support" exact={true} component={CrewSupport} />
        <Route component={() => <Redirect to="/" />} />
      </Switch>
      <TrayBar offerId={offer} from={fromSystem} />
    </>
  );
};

export default withAuthProtection()(OfferPage);
